/* Guided presentation: existing option nodes and configurator handlers are retained. */
(function () {
  'use strict';
  const optionsOf = v => v.options || [v.option1, v.option2, v.option3].filter(x => x != null);
  function comparison(variants, current, index, value) {
    if (!current || !Number.isInteger(index)) return null;
    const wanted = optionsOf(current).slice();
    wanted[index] = value;
    const target = variants.find(v => {
      const options = optionsOf(v);
      return options.length === wanted.length && options.every((x, i) => x === wanted[i]);
    });
    if (!target || !Number.isFinite(Number(target.price)) || !Number.isFinite(Number(current.price))) return null;
    return { variant: target, delta: Number(target.price) - Number(current.price), selected: String(target.id) === String(current.id) };
  }
  window.pv2CompareVariantPrice = comparison;
  const money = cents => new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  // Existing Shopify image URLs retained as a fallback if theme mapping loads late.
  const fallbackImages = {
   'Ral 9005 sort': 'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-9005-sort-forudbestilling_3e52703e-903e-40ca-815e-b59472c35e7f.webp?v=1687517211',
    'Ubehandlet aluminium': 'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ubeh-aluminium-forudbestilling.png?v=1688487582',
    'Ubehandlet aluminium FORUDBESTILLING': 'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ubeh-aluminium-forudbestilling.png?v=1688487582',
    'Ral 6009 army grøn': 'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-6009-army-gron.png?v=1676054283',
    'Ral 6009 army grøn FORUDBESTILLING': 'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-6009-army-gron.png?v=1676054283',
    'Ral 9010 hvid':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-9010-hvid_44c99d49-ae70-443c-bec8-0c55a94d9ec3.webp?v=1698168287',
    'Ral 9010 hvid FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-9010-hvid_44c99d49-ae70-443c-bec8-0c55a94d9ec3.webp?v=1698168287',
    'Ral 7016 antracit grå':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-7016-grey.webp?v=1698168664',
    'Sider: 4mm hærdet glas. tag: 6mm poly':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    'Sider: 4mm hærdet glas. tag: 6mm poly.':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    '6 mm. polycarbonat komplet':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/poly.webp?v=1698169372',
    '4 mm. polycarbonat komplet':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/poly.webp?v=1698169372',
    '4 mm hærdet glas komplet':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glass_b39a8faf-6fdc-450a-b673-8cdaa505617f.webp?v=1698169651',
    'Sider: 4mm hærdet glas. tag: 10mm poly':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    'Sider: 4mm hærdet glas. tag: 10mm poly FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    'Sider: 4mm hærdet glas. tag: 10mm polycarbonat':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    'Sider: 4mm hærdet glas. tag: 10mm polycarbonat FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glaas-poly_cc7ed830-e928-4456-8cac-dfa1cc997404.webp?v=1698169652',
    '4 mm. hærdet helbaneglas komplet':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glass_b39a8faf-6fdc-450a-b673-8cdaa505617f.webp?v=1698169651',
    '4 mm. hærdet helbaneglas komplet FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glass_b39a8faf-6fdc-450a-b673-8cdaa505617f.webp?v=1698169651',
    '4 mm hærdet glas komplet FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/glass_b39a8faf-6fdc-450a-b673-8cdaa505617f.webp?v=1698169651',
    '10 mm. polycarbonat komplet':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/poly.webp?v=1698169372',
    'Ral 9005 sort FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ral-9005-sort-forudbestilling_3e52703e-903e-40ca-815e-b59472c35e7f.webp?v=1687517211',
    'Dobbelt skydedøre':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-video-to-gif_719f7765-985b-4130-8cb7-6391c6afd9cf.gif?v=1701688220',
    'Dobbelt hængslet stalddøre':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-crop.gif?v=1701688328',

    'Dobbelt skydedøre med lås centreret på langside FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Dobbelt hængslet døre med lås centreret på langside FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Dobbelt hængslet døre med lås centreret i gavl FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
     'Dobbelt skydedøre med lås centreret på langside':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Dobbelt hængslet døre med lås centreret på langside':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Dobbelt hængslet døre med lås centreret i gavl':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',

    'Dobbelt skydedøre centreret på langside':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-video-to-gif_719f7765-985b-4130-8cb7-6391c6afd9cf.gif?v=1701688220',
    'Dobbelt hængslet stalddøre centreret på langside':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-crop.gif?v=1701688328',
    'Dobbelt hængslet stalddøre centreret i gavl':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-crop.gif?v=1701688328',
    'Dobbelt skydedøre med lås (uden sprosser) FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Dobbelt skydedøre med lås (uden sprosser)':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/124fdsc_b309236e-9678-43dc-8b21-d431ace7af2f.jpg?v=1769518375',
    'Ingen sokkel':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/4124dfsq_751b121a-a901-4185-9d48-53422435a8df.jpg?v=1763975069',
    'Blank stål sokkel':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/2_1_264aaf9d-a9e3-4a25-bf3f-9e352ba26c7f.jpg?v=1750329239',
    'Malet sokkel':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/1_1_48a6ba2e-4f1e-4dc2-ab53-4db65083ac94.jpg?v=1750329239',
    'Dobbelt hængslet stalddøre FORUDBESTILLING':'https://cdn.shopify.com/s/files/1/0593/4707/5259/files/ezgif.com-crop.gif?v=1701688328'

 };
  function choiceImage(value) {
    return window.imageMap?.[value] || fallbackImages[value] || fallbackImages[String(value).replace(/ FORUDBESTILLING$/i, "")];
  }
  function defaultChoiceBadge(kind, value) {
    const text = String(value || '').toLocaleLowerCase('da-DK');
    if (kind === 'color' && (/9005/.test(text) || /\bsort\b/.test(text))) return 'Mest populære';
    if (kind === 'material') {
      if (/poly/.test(text)) return 'God til dyrkning';
      if (/glas/.test(text)) return 'Mest populære';
    }
    if (kind === 'door' && /skyde/.test(text)) return 'Vi anbefaler';
    return '';
  }
  function init() {
    const right = document.querySelector('.pv2-design-right');
    const picker = right && right.querySelector('#pv2-variant-picker');
    if (!picker || right.classList.contains('pv2-guided')) return;
    const cards = Array.from(right.querySelectorAll('.pv2-option-card')).filter(c => !c.parentElement.closest('.pv2-option-card'));
    if (!cards.length) return;
    const core = cards.filter(c => picker.contains(c));
    const indexes = new Map();
    core.forEach((card, fallback) => {
      const item = card.querySelector('.pv2-option-value-item[data-option-index]');
      indexes.set(card, item ? Number(item.dataset.optionIndex) : fallback);
    });
    function currentVariant() {
      const variants = window.pv2Variants || [];
      const choices = [];
      core.forEach(card => {
        const active = card.querySelector('.pv2-option-value-item.active');
        if (active) choices[indexes.get(card)] = active.dataset.value;
      });
      return variants.find(v => {
        const options = optionsOf(v);
        return options.length === core.length && options.every((x, i) => x === choices[i]);
      }) || null;
    }
    function updatePrices() {
      const current = currentVariant();
      core.forEach(card => card.querySelectorAll('.pv2-option-value-item').forEach(item => {
        let box = item.querySelector('.pv2-guided-price');
        if (!box) {
          box = document.createElement('span'); box.className = 'pv2-guided-price'; item.append(box);
        }
        const result = comparison(window.pv2Variants || [], current, indexes.get(card), item.dataset.value);
        item.dataset.pv2Missing = current && !result ? 'true' : 'false';
        box.textContent = !current ? 'Vælg en gyldig kombination' : !result ? 'Kombination findes ikke' : result.selected ? 'Valgt' : result.delta === 0 ? 'Ingen merpris' : (result.delta > 0 ? '+ ' : '− ') + money(Math.abs(result.delta));
        item.setAttribute('aria-pressed', String(item.classList.contains('active')));
        item.setAttribute('aria-disabled', String(item.dataset.pv2Missing === 'true'));
        // Never present static prices from the old manual price table.
        item.querySelectorAll('.pv2-option-value-price, [data-price]').forEach(old => old.hidden = true);
      }));
    }
    window.pv2UpdateGuidedPrices = updatePrices;
    right.classList.add('pv2-guided', 'pv2-scroll-design');
    const titleOf = card => (card.querySelector('.pv2-option-card-title')?.textContent || 'Vælg mulighed').trim();
    const titleBox = right.querySelector('.pv2-title-box');
    if (titleBox) {
      const title = document.createElement('h2'); title.className = 'pv2-scroll-title'; title.textContent = 'Design dit drivhus'; titleBox.prepend(title);
    }
    core.forEach((card, i) => {
      const optionName = titleOf(card);
      card.dataset.pv2Kind = /farve/i.test(optionName) ? 'color' : /beklædning/i.test(optionName) ? 'material' : /^dør(e)?$/i.test(optionName) ? 'door' : 'standard';
      const title = card.querySelector('.pv2-option-card-title');
      if (title) title.textContent = (i + 1) + '. Vælg ' + optionName.toLocaleLowerCase('da-DK');
      card.dataset.pv2OptionName = optionName;
    });
    const accessoryNames = {
      'extra-door-card': ['Ekstra dør', 'Ekstra adgang'],
      'shelf-addon-card': ['Hylder', ''],
      'ophaengskroge-card': ['Ophængskroge', 'Udnyt højden'],
      'auto-opluk-card': ['Automatisk vinduesåbner', ''],
      'ridge-decoration-card': ['Tagdekoration', 'Personligt udtryk'],
      'montage-referral-card': ['Montering', 'Få hjælp til monteringen']
    };
    const editorial = window.pv2GuidedBadges || {};
    cards.filter(card => !core.includes(card)).forEach(card => {
      const info = accessoryNames[card.id];
      if (!info) return;
      const title = card.querySelector('.pv2-option-card-title');
      card.dataset.pv2Label = info[0];
      if (title) {
        title.textContent = info[0];
        const text = editorial[card.id] === undefined ? info[1] : editorial[card.id];
        if (typeof text === 'string' && text.trim()) {
          const badge = document.createElement('span'); badge.className = 'pv2-guided-badge'; badge.textContent = text; title.append(badge);
        }
      }
    });
    updatePrices();
    // Editorial copy is optional and keyed by the exact option title/value.
    const badges = window.pv2GuidedBadges || {};
    const descriptions = window.pv2GuidedDescriptions || {};
    core.forEach(card => card.querySelectorAll('.pv2-option-value-item').forEach(item => {
      const content = document.createElement('div'); content.className = 'pv2-guided-choice-content';
      const label = document.createElement('span'); label.className = 'pv2-guided-choice-title'; label.textContent = item.dataset.displayLabel || item.dataset.value;
      if (card.dataset.pv2Kind === 'color') {
        const value = item.dataset.value.toLocaleLowerCase('da-DK');
        const names = [['9005','Sort'], ['6009','Grøn'], ['7016','Grå'], ['9010','Hvid']];
        const match = names.find(([code]) => value.includes(code));
        if (match) label.textContent = match[1] + (value.includes('forudbestilling') ? ' · Forudbestilling' : '');
        else if (value.includes('ubehandlet')) label.textContent = 'Aluminium' + (value.includes('forudbestilling') ? ' · Forudbestilling' : '');
      }
      let image = item.querySelector('.pv2-option-value-image');
      const imageSource = item.dataset.img || choiceImage(item.dataset.value);
      if (image && !image.getAttribute('src') && !imageSource) image = null;
      if (image && imageSource) image.src = imageSource;
      if (!image && imageSource) { image = document.createElement('img'); image.className = 'pv2-option-value-image'; image.src = imageSource; }
      if (image) { image.alt = ''; image.classList.add('pv2-guided-choice-image'); item.prepend(image); }
      // Hide the old label/price wrappers but keep their nodes for theme compatibility.
      Array.from(item.children).forEach(child => { if (child !== image) child.classList.add('pv2-guided-original'); });
      const priceBox = item.querySelector('.pv2-guided-price');
      if (priceBox) { priceBox.classList.remove('pv2-guided-original'); content.append(priceBox); }
      content.prepend(label);
      const hasAlternatives = card.querySelectorAll('.pv2-option-value-item').length > 1;
      const badgeText = hasAlternatives ? (badges[card.dataset.pv2OptionName || titleOf(card)]?.[item.dataset.value] ?? defaultChoiceBadge(card.dataset.pv2Kind, item.dataset.value)) : '';
      if (typeof badgeText === 'string' && badgeText.trim()) {
        const badge = document.createElement('span'); badge.className = 'pv2-guided-badge'; badge.textContent = badgeText; label.after(badge);
      }
      const descriptionText = descriptions[card.dataset.pv2OptionName || titleOf(card)]?.[item.dataset.value] || item.dataset.description;
      if (typeof descriptionText === 'string' && descriptionText.trim()) {
        const description = document.createElement('span'); description.className = 'pv2-guided-description'; description.textContent = descriptionText;
        if (priceBox) priceBox.before(description); else content.append(description);
      }
      const radio = document.createElement('span'); radio.className = 'pv2-guided-radio'; radio.setAttribute('aria-hidden', 'true');
      // Text-only labels have no image wrapper to hide.
      Array.from(item.childNodes).forEach(node => { if (node.nodeType === 3 && node.textContent.trim()) node.textContent = ''; });
      item.append(content, radio); item.classList.toggle('pv2-guided-no-image', !image);
      if (!['BUTTON', 'INPUT', 'SELECT'].includes(item.tagName)) {
        item.setAttribute('role', 'button'); item.tabIndex = 0;
        item.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); item.click(); }
        });
      }
    }));
    right.addEventListener('click', event => {
      const item = event.target.closest('.pv2-option-value-item');
      if (item?.dataset.pv2Missing === 'true') { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    // Visual accessory choices retain each original select as the source of truth.
    const accessorySelectors = '#foundation-accessory-variant-select, #extra-door-variant-select, .shelf-variant-dropdown, #ophaengskroge-variant-select, #auto-opluk-variant-select, #ridge-decoration-variant-select';
    function accessoryImage(option) {
      if (option.dataset.image) return option.dataset.image;
      const text = option.textContent.trim().replace(/\s*\(Udsolgt\)\s*$/i, '');
      const exact = choiceImage(text);
      if (exact) return exact;
      const colors = [
        [/9005|\bsort\b/i, 'Ral 9005 sort'],
        [/6009|grøn/i, 'Ral 6009 army grøn'],
        [/7016|antracit|grå/i, 'Ral 7016 antracit grå'],
        [/9010|\bhvid\b/i, 'Ral 9010 hvid'],
        [/aluminium|alu\b|ubehandlet|blank/i, 'Ubehandlet aluminium']
      ];
      const match = colors.find(([pattern]) => pattern.test(text));
      return match ? choiceImage(match[1]) : null;
    }
    right.querySelectorAll(accessorySelectors).forEach(select => {
      const productTitle = select.closest('.shelf-addon-product')?.dataset.title || '';
      if (select.id === 'extra-door-variant-select' || /lamelbord/i.test(productTitle)) {
        select.classList.add('pv2-visible-variant-dropdown');
        return;
      }
      const group = document.createElement('div'); group.className = 'pv2-accessory-swatches';
      group.setAttribute('role', 'group'); group.setAttribute('aria-label', 'Vælg variant');
      select.classList.add('pv2-accessory-native-select'); select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      const field = select.parentElement; field.classList.add('pv2-accessory-color-field');
      field.parentElement?.classList.add('pv2-accessory-controls');
      const label = field.querySelector('label');
      if (label) { group.setAttribute('aria-label', label.textContent.trim()); label.removeAttribute('for'); }
      select.after(group);
      const buttons = Array.from(select.options).map(option => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'pv2-accessory-swatch';
        const source = accessoryImage(option);
        if (source) { const image = document.createElement('img'); image.src = source; image.alt = ''; image.width = 44; image.height = 44; button.append(image); }
        const text = document.createElement('span');
        const fullTitle = option.textContent.trim();
        button.title = fullTitle;
        text.textContent = fullTitle.replace(/^Ral 9005 sort$/i, 'Sort').replace(/^Ral 9010 hvid$/i, 'Hvid').replace(/^Ral 6009 army grøn$/i, 'Grøn').replace(/^Ral 7016 antracit grå$/i, 'Grå').replace(/^Ubehandlet aluminium$/i, 'Aluminium');
        button.append(text);
        button.disabled = option.disabled || option.dataset.available === 'false';
        if (button.disabled) button.setAttribute('aria-label', text.textContent + ' – udsolgt');
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
        group.append(button); return { button, option };
      });
      function sync() {
        buttons.forEach(({ button, option }) => {
          const selected = select.value === option.value;
          button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
        });
      }
      select.addEventListener('change', sync);
      sync();
    });
    // Compact product rows: retain original fields and event handlers inside each card.
    const compactSpecs = [
      ['extra-door-card', 'extra-door-image', 'extra-door-variant-select', 'extra-door-qty-select', 'extra-door-options'],
      ['ophaengskroge-card', 'ophaengskroge-image', 'ophaengskroge-variant-select', 'ophaengskroge-qty-select', 'ophaengskroge-options'],
      ['auto-opluk-card', 'auto-opluk-image', 'auto-opluk-variant-select', 'auto-opluk-qty-select', 'auto-opluk-options'],
      ['ridge-decoration-card', 'ridge-decoration-image', 'ridge-decoration-variant-select', null, 'ridge-decoration-options']
    ];
    const formatAccessoryPrice = value => money(Math.round(Number(value || 0) * 100));
    compactSpecs.forEach(([id, imageId, selectId, qtyId, optionsId]) => {
      const card = right.querySelector('#' + id);
      if (!card) return;
      card.classList.add('pv2-compact-product');
      const title = card.querySelector('.pv2-option-card-title');
      const image = card.querySelector('#' + imageId);
      const select = card.querySelector('#' + selectId);
      const qty = qtyId ? card.querySelector('#' + qtyId) : null;
      const add = card.querySelector('.pv2-option-value-item[data-value="add"]');
      const none = card.querySelector('.pv2-option-value-item[data-value="none"]');
      if (!title || !add || !none) return;
      const oldImageRow = image?.parentElement.parentElement;
      if (oldImageRow) oldImageRow.classList.add('pv2-compact-original-row');
      const header = document.createElement('div'); header.className = 'pv2-compact-header';
      const unit = document.createElement('span'); unit.className = 'pv2-compact-unit';
      if (image) header.append(image);
      header.append(title, unit); card.prepend(header);
      const options = card.querySelector('#' + optionsId);
      if (options) options.classList.add('pv2-compact-options');
      if (qty) qty.parentElement.classList.add('pv2-compact-original-qty');
      const stepper = document.createElement('div'); stepper.className = 'pv2-compact-stepper';
      const minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Fjern én');
      const amount = document.createElement('span'); amount.setAttribute('aria-live', 'polite');
      const plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Tilføj én');
      stepper.append(minus, amount, plus);
      const swatches = options?.querySelector('.pv2-accessory-swatches');
      if (swatches) swatches.after(stepper); else if (select) select.after(stepper); else header.append(stepper);
      const values = qty ? Array.from(qty.options).map(o => Number(o.value)).filter(v => v > 0) : [1];
      function count() { return add.classList.contains('active') ? (qty ? Number(qty.value) : 1) : 0; }
      function setCount(value) {
        if (value === 0) none.click();
        else {
          if (qty) { qty.value = String(value); qty.dispatchEvent(new Event('change', { bubbles: true })); }
          if (!add.classList.contains('active')) add.click();
        }
        sync();
      }
      minus.addEventListener('click', () => {
        const index = values.indexOf(count()); setCount(index <= 0 ? 0 : values[index - 1]);
      });
      plus.addEventListener('click', () => {
        const index = values.indexOf(count()); if (index < values.length - 1) setCount(values[index + 1]);
      });
      function sync() {
        const value = count(); amount.textContent = String(value);
        minus.disabled = value === 0; plus.disabled = value === values[values.length - 1];
        const selected = select?.selectedOptions[0];
        unit.textContent = selected ? formatAccessoryPrice(selected.dataset.price) : '';
        if (card.classList.contains('pv2-compact-added') !== (value > 0)) card.classList.toggle('pv2-compact-added', value > 0);
        const unavailable = selected?.dataset.available === 'false';
        if (unavailable) plus.disabled = true;
      }
      select?.addEventListener('change', sync); qty?.addEventListener('change', sync);
      new MutationObserver(sync).observe(card, { subtree: true, attributes: true, attributeFilter: ['class'] });
      sync();
    });
    const foundationQty = right.querySelector('#foundation-accessory-qty-select');
    if (foundationQty) {
      const wrap = document.createElement('div'); wrap.className = 'pv2-compact-stepper';
      const minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Fjern én dækkappe');
      const amount = document.createElement('span'); amount.setAttribute('aria-live', 'polite');
      const plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Tilføj én dækkappe');
      const values = Array.from(foundationQty.options).map(option => option.value);
      function sync() { const index = values.indexOf(foundationQty.value); amount.textContent = foundationQty.value; minus.disabled = index <= 0; plus.disabled = index >= values.length - 1; }
      function change(direction) { const index = values.indexOf(foundationQty.value) + direction; if (index >= 0 && index < values.length) { foundationQty.value = values[index]; foundationQty.dispatchEvent(new Event('change', { bubbles: true })); } }
      minus.addEventListener('click', () => change(-1)); plus.addEventListener('click', () => change(1));
      foundationQty.addEventListener('change', sync); foundationQty.classList.add('pv2-accessory-native-select'); foundationQty.tabIndex = -1;
      wrap.append(minus, amount, plus); foundationQty.after(wrap); sync();
    }
    right.querySelectorAll('.shelf-addon-product').forEach(product => {
      const heading = product.querySelector('.shelf-product-heading');
      if (heading) {
        heading.title = heading.textContent.trim();
        // Preserve the product's original title; no automatic shortening.
      }
      const info = product.querySelector('.shelf-addon-info');
      const select = product.querySelector('.shelf-variant-dropdown');
      if (!info || !select) return;
      const unit = document.createElement('span'); unit.className = 'pv2-shelf-unit'; info.append(unit);
      function sync() {
        const input = Array.from(product.querySelectorAll('.shelf-qty-input')).find(input => input.dataset.variant === select.value);
        unit.textContent = input ? formatAccessoryPrice(input.dataset.price) : '';
      }
      select.addEventListener('change', sync); sync();
    });
    const shelfCard = right.querySelector('#shelf-addon-card');
    const discountTable = shelfCard?.querySelector('table');
    if (discountTable) {
      const details = document.createElement('details'); details.className = 'pv2-compact-details';
      const summary = document.createElement('summary'); summary.textContent = 'Se mængderabat · op til 30 %';
      discountTable.before(details); details.append(summary, discountTable);
    }
    right.querySelectorAll('.pv2-option-card:not([data-pv2-kind]) > .helper-description').forEach(description => {
      const details = document.createElement('details'); details.className = 'pv2-compact-details';
      const summary = document.createElement('summary'); summary.textContent = 'Læs mere';
      description.before(details); details.append(summary, description);
    });
    // Keep existing price nodes and the live Klaviyo form; only rearrange presentation.
    const mounting = right.querySelector('#montage-referral-card');
    const mountingOptions = mounting?.querySelector('#montage-referral-options');
    if (mounting && mountingOptions) {
      mounting.classList.add('pv2-mounting-price-focus');
      const oldImage = mounting.querySelector('#montage-referral-image');
      const oldChoices = mounting.querySelector('.pv2-option-values');
      const originalRow = oldChoices?.parentElement?.parentElement;
      if (originalRow && originalRow !== mounting) originalRow.hidden = true;
      else if (oldImage) oldImage.hidden = true;
      const badge = mounting.querySelector('.pv2-guided-badge');
      if (badge) badge.textContent = 'Ekstern montør';
      const description = mountingOptions.children[0];
      if (description) { description.classList.add('pv2-mounting-intro'); description.textContent = 'Vi henviser dig til en ekstern montør i dit område.'; }
      const label = mounting.querySelector('#montage-referral-pricetext');
      const range = mounting.querySelector('#montage-referral-pricerange');
      const originalPriceRow = range?.parentElement?.parentElement;
      if (label && range && originalPriceRow) {
        const note = originalPriceRow.nextElementSibling;
        const priceBox = document.createElement('div'); priceBox.className = 'pv2-mounting-price-box';
        originalPriceRow.before(priceBox); priceBox.append(label, range);
        if (note && !note.classList.contains('klaviyo-form-WEWR9P')) {
          note.classList.add('pv2-mounting-price-note'); note.textContent = 'Vejledende pris. Aftales direkte med montøren.'; priceBox.append(note);
        }
        originalPriceRow.remove();
      }
      const form = mountingOptions.querySelector('.klaviyo-form-WEWR9P');
      if (form) {
        const formBox = document.createElement('div'); formBox.className = 'pv2-mounting-form-box';
        const heading = document.createElement('h3'); heading.textContent = 'Få kontakt til en montør';
        form.before(formBox); formBox.append(heading, form);
      }
    }
    const foundation = right.querySelector('#foundation-type-card');
    if (foundation) {
      foundation.classList.add('pv2-foundation-image-choices');
      const image = foundation.querySelector('#foundation-type-image');
      if (image) { image.classList.add('pv2-option-card-image'); image.parentElement.classList.add('pv2-option-card-image-wrap'); }
      if (image?.parentElement) image.parentElement.hidden = false;
    }
    // Accessible accordion: one panel at a time, existing controls remain intact.
    const skipLabels = {
      'extra-door-card': 'Ingen ekstra dør',
      'shelf-addon-card': 'Ingen hylder',
      'ophaengskroge-card': 'Ingen kroge',
      'auto-opluk-card': 'Ingen vinduesåbner',
      'ridge-decoration-card': 'Ingen tagdekoration',
      'montage-referral-card': 'Ingen montering'
    };
    const accordionPanels = [];
    cards.forEach((card, index) => {
      const title = card.querySelector('.pv2-option-card-title');
      if (!title) return;
      const heading = document.createElement('button'); heading.type = 'button'; heading.className = 'pv2-accordion-toggle';
      const name = document.createElement('span'); name.className = 'pv2-accordion-name';
      name.textContent = card.dataset.pv2OptionName || accessoryNames[card.id]?.[0] || ({ 'foundation-type-card': 'Fastgørelse til underlag', 'door-placement-card': 'Placering af dør' })[card.id] || title.textContent.trim();
      if (['shelf-addon-card', 'auto-opluk-card'].includes(card.id)) {
        const text = editorial[card.id] === undefined ? accessoryNames[card.id][1] : editorial[card.id];
        if (typeof text === 'string' && text.trim()) {
          const badge = document.createElement('span'); badge.className = 'pv2-guided-badge'; badge.textContent = text; badge.style.marginLeft = '8px'; name.append(badge);
        }
      }
      const selected = document.createElement('span'); selected.className = 'pv2-accordion-selection';
      const chevron = document.createElement('span'); chevron.className = 'pv2-accordion-chevron'; chevron.textContent = 'Ændre';
      heading.append(name, selected, chevron);
      const body = document.createElement('div'); body.className = 'pv2-accordion-body'; body.id = 'pv2-accordion-panel-' + index;
      heading.setAttribute('aria-controls', body.id);
      Array.from(card.childNodes).forEach(node => body.append(node));
      title.classList.add('pv2-accordion-original-title');
      card.append(heading, body); card.classList.add('pv2-accordion-card');
      function setOpen(open) { body.hidden = !open; card.dataset.pv2Open = String(open); heading.setAttribute('aria-expanded', String(open)); chevron.textContent = open ? 'Luk' : 'Ændre'; }
      setOpen(index === 0);
      const panel = { card, body, heading, selected, setOpen };
      accordionPanels.push(panel);
      heading.addEventListener('click', () => {
        const open = body.hidden;
        accordionPanels.forEach(other => other.setOpen(other === panel && open));
        if (open) requestAnimationFrame(() => scrollToPanel(panel));
      });
      body.addEventListener('focusin', () => {
        if (body.hidden) { accordionPanels.forEach(other => other.setOpen(other === panel)); }
      });
      function updateSelection() {
        if (card.id === 'montage-referral-card') {
          const noAssembly = card.querySelector('.pv2-option-value-item[data-value=none]')?.classList.contains('active');
          const estimate = card.querySelector('#montage-referral-pricerange')?.textContent.trim();
          selected.textContent = (noAssembly ? skipLabels[card.id] : 'Henvisning til montør') + (estimate ? ' · Estimeret: ' + estimate : '');
          return;
        }
        if (card.id === 'shelf-addon-card') {
          const quantity = Array.from(card.querySelectorAll('.shelf-qty-input')).reduce((sum, input) => sum + (Number(input.value) || 0), 0);
          selected.textContent = quantity ? quantity + ' stk. valgt' : 'Ingen hylder'; return;
        }
        const stepper = card.querySelector('.pv2-compact-stepper > span');
        if (card.classList.contains('pv2-compact-product')) {
          const quantity = Number(stepper?.textContent || 0);
          const select = card.querySelector('select');
          selected.textContent = quantity ? quantity + ' stk. · ' + (select?.selectedOptions[0]?.textContent.trim() || '') : (skipLabels[card.id] || 'Ingen valgt'); return;
        }
        const active = card.querySelector('.pv2-option-value-item.active');
        selected.textContent = active?.dataset.value || active?.textContent.trim() || 'Se muligheder';
        if (card.id === 'foundation-type-card') selected.textContent = active?.querySelector('.pv2-option-value-label')?.textContent.trim() || selected.textContent;
      }
      card.addEventListener('click', () => requestAnimationFrame(updateSelection));
      card.addEventListener('change', () => requestAnimationFrame(updateSelection));
      card.addEventListener('input', () => requestAnimationFrame(updateSelection));
      new MutationObserver(() => requestAnimationFrame(updateSelection)).observe(body, {subtree:true, attributes:true, attributeFilter:['class']});
      updateSelection();
      panel.updateSelection = updateSelection;
      let accessoryContent = null;
      if (skipLabels[card.id] && card.id !== 'shelf-addon-card') {
        const none = card.querySelector('.pv2-option-value-item[data-value="none"]');
        const add = card.querySelector('.pv2-option-value-item[data-value="add"]');
        if (none && add) {
          const choices = document.createElement('div'); choices.className = 'pv2-step-addon-choices';
          const skip = document.createElement('button'); skip.type = 'button'; skip.className = 'pv2-step-skip'; skip.textContent = skipLabels[card.id];
          const yes = document.createElement('button'); yes.type = 'button'; yes.className = 'pv2-step-add'; yes.textContent = 'Ja tak, tilføj';
          accessoryContent = document.createElement('div'); accessoryContent.className = 'pv2-step-addon-content'; accessoryContent.id = body.id + '-content';
          Array.from(body.childNodes).forEach(node => accessoryContent.append(node));
          yes.setAttribute('aria-controls', accessoryContent.id);
          choices.append(skip, yes);
          // The estimate is informational and remains visible for both referral choices.
          const estimate = card.id === 'montage-referral-card' ? accessoryContent.querySelector('.pv2-mounting-price-box') : null;
          if (estimate) body.append(estimate);
          body.append(choices, accessoryContent);
          function syncAddon() {
            const enabled = add.classList.contains('active');
            accessoryContent.hidden = !enabled;
            yes.setAttribute('aria-expanded', String(enabled)); yes.setAttribute('aria-pressed', String(enabled));
            skip.setAttribute('aria-pressed', String(!enabled));
          }
          yes.addEventListener('click', () => { add.click(); syncAddon(); updateSelection(); });
          skip.addEventListener('click', () => {
            none.click(); syncAddon();
            requestAnimationFrame(() => advance(panel));
          });
          new MutationObserver(syncAddon).observe(card, {subtree:true, attributes:true, attributeFilter:['class']});
          syncAddon();
        }
      }
      if (card.id === 'shelf-addon-card') {
        const inputs = Array.from(card.querySelectorAll('.shelf-qty-input'));
        let enabled = inputs.some(input => Number(input.value) > 0);
        const choices = document.createElement('div'); choices.className = 'pv2-step-addon-choices';
        const skip = document.createElement('button'); skip.type = 'button'; skip.className = 'pv2-step-skip'; skip.textContent = 'Ingen hylder';
        const yes = document.createElement('button'); yes.type = 'button'; yes.className = 'pv2-step-add'; yes.textContent = 'Tilføj hylder';
        accessoryContent = document.createElement('div'); accessoryContent.className = 'pv2-step-addon-content'; accessoryContent.id = body.id + '-content';
        Array.from(body.childNodes).forEach(node => accessoryContent.append(node));
        yes.setAttribute('aria-controls', accessoryContent.id);
        choices.append(skip, yes); body.append(choices, accessoryContent);
        function syncShelves() {
          accessoryContent.hidden = !enabled;
          yes.setAttribute('aria-expanded', String(enabled)); yes.setAttribute('aria-pressed', String(enabled)); skip.setAttribute('aria-pressed', String(!enabled));
        }
        yes.addEventListener('click', () => { enabled = true; syncShelves(); });
        skip.addEventListener('click', () => {
          inputs.forEach(input => {
            input.value = '0';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          enabled = false; syncShelves(); updateSelection();
          requestAnimationFrame(() => advance(panel));
        });
        function restoreShelves() { if (inputs.some(input => Number(input.value) > 0)) { enabled = true; syncShelves(); } }
        card.addEventListener('input', restoreShelves); card.addEventListener('change', restoreShelves);
        syncShelves();
      }
      const needsConfirmation = !core.includes(card) && card.id !== 'door-placement-card';
      if (needsConfirmation) {
        const next = document.createElement('button'); next.type = 'button'; next.className = 'pv2-step-continue'; next.textContent = 'Fortsæt';
        (accessoryContent || body).append(next);
        const placement = card.id === 'extra-door-card' ? card.querySelector('#extra-door-placement-comment') : null;
        let placementError = null;
        if (placement) {
          placementError = document.createElement('p'); placementError.id = body.id + '-placement-error'; placementError.className = 'pv2-placement-error';
          placementError.textContent = 'Skriv, hvor den eller de ekstra døre skal placeres, før du fortsætter.'; placementError.hidden = true; placementError.setAttribute('role', 'alert');
          placement.after(placementError);
          const describedBy = placement.getAttribute('aria-describedby');
          placement.setAttribute('aria-describedby', [describedBy, placementError.id].filter(Boolean).join(' '));
          placement.setAttribute('aria-required', 'true');
          placement.addEventListener('input', () => {
            if (placement.value.trim()) { placementError.hidden = true; placement.removeAttribute('aria-invalid'); }
          });
        }
        next.addEventListener('click', () => {
          const hasExtraDoor = card.id === 'extra-door-card' && card.querySelector('.pv2-option-value-item[data-value="add"]')?.classList.contains('active');
          if (hasExtraDoor && placement && !placement.value.trim()) {
            placementError.hidden = false; placement.setAttribute('aria-invalid', 'true'); placement.focus();
            return;
          }
          if (placementError) { placementError.hidden = true; placement.removeAttribute('aria-invalid'); }
          advance(panel);
        });
      }
      function completeSimpleChoice(event) {
        // Restore hooks issue synthetic clicks; they must never advance the UI.
        if (!event.isTrusted || body.hidden || needsConfirmation) return;
        const item = event.target.closest('.pv2-option-value-item');
        if (!item || item.dataset.pv2Missing === 'true' || item.getAttribute('aria-disabled') === 'true') return;
        requestAnimationFrame(() => { if (item.classList.contains('active')) advance(panel); });
      }
      body.addEventListener('click', completeSimpleChoice);
      body.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') completeSimpleChoice(event);
      });
    });
    // Start at colour, even when Shopify lists a different option first.
    const colour = accordionPanels.find(panel => panel.card.dataset.pv2Kind === 'color');
    if (colour) {
      picker.prepend(colour.card);
      accordionPanels.splice(accordionPanels.indexOf(colour), 1);
      accordionPanels.unshift(colour);
    }
    accordionPanels.forEach((panel, index) => panel.setOpen(index === 0));
    function scrollToPanel(panel) {
      const topSpace = window.innerWidth <= 792 ? 116 : 16;
      const behavior = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      // Scroll the modal's actual scrolling surface, without moving the page behind it.
      if (typeof getComputedStyle === 'function' && panel.card.getBoundingClientRect) {
        for (let surface = panel.card.parentElement; surface && surface !== document.body; surface = surface.parentElement) {
          if (/(auto|scroll)/.test(getComputedStyle(surface).overflowY) && surface.scrollHeight > surface.clientHeight + 1) {
            const offset = panel.card.getBoundingClientRect().top - surface.getBoundingClientRect().top;
            surface.scrollTo({ top: Math.max(0, surface.scrollTop + offset - topSpace - (surface.clientTop || 0)), behavior });
            return;
          }
        }
      }
      panel.card.style.scrollMarginTop = topSpace + 'px';
      panel.card.scrollIntoView({ behavior, block: 'start' });
    }
    function advance(panel) {
      const index = accordionPanels.indexOf(panel);
      const next = accordionPanels[index + 1];
      panel.updateSelection();
      accordionPanels.forEach(other => other.setOpen(other === next));
      if (next) {
        next.heading.focus({ preventScroll: true });
        requestAnimationFrame(() => scrollToPanel(next));
      }
    }
    let frame = 0;
    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; updatePrices(); });
    }
    right.addEventListener('click', schedule);
    right.addEventListener('change', schedule);
    right.addEventListener('input', schedule);
    new MutationObserver(schedule).observe(picker, { subtree: true, attributes: true, attributeFilter: ['class'] });
    updatePrices();

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0));
  else init();
})();
